import React from "react";
import { PageShell, EditableSection, EditableFeatureGrid } from "./PageShell";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PARTNERS = [
  { badge: "Boutiques", title: "Independent perfumeries", body: "Curated fragrance boutiques and lifestyle retailers looking to stock a modern impression line alongside their premium brands." },
  { badge: "Salons & spas", title: "Beauty & wellness", body: "Hair salons, day spas, and wellness studios seeking a signature scent programme for retail and treatment areas." },
  { badge: "Hotels", title: "Hospitality partners", body: "Boutique hotels and resorts interested in in-room amenities or turndown gifts branded to the property." },
  { badge: "Gift shops", title: "Considered gifting", body: "Museum stores, gallery shops, and gift boutiques with a discerning clientele." },
  { badge: "Corporate", title: "B2B gifting programmes", body: "Bulk engraved orders for corporate gifting, client onboarding, or executive presents." },
  { badge: "Weddings", title: "Wedding party gifting", body: "Custom-engraved roll-ons and 50ml bottles for wedding parties and welcome bags." },
];

const BENEFITS = [
  { badge: "Margins", title: "Sustainable wholesale pricing", body: "Wholesale margins that let you present Scentodore at a competitive retail price while protecting your bottom line." },
  { badge: "Territory", title: "Distribution guardrails", body: "We limit how many partners we take on within a geography so you’re not competing with the shop down the block." },
  { badge: "Marketing", title: "Co-marketing support", body: "Sampling programmes, window displays, and content assets provided to help you introduce Scentodore to your customers." },
  { badge: "Custom", title: "White-label options", body: "For hotel groups, wedding planners, and gifting programmes we offer custom formulations, engraving, and packaging." },
];

const PROCESS = [{
  heading: "How the partnership process works",
  body: "1. Introduce your business — share your storefront, customer base, and current fragrance lineup.\n\n2. We review new applications weekly and reply within 5 business days.\n\n3. If a fit, we send an assortment recommendation, pricing sheet, and sample kit.\n\n4. First orders are typically 24 units and can mix any combination of our 50ml bottles and roll-ons.",
}];

const NOTE = [{
  heading: "A note on exclusivity",
  body: "We grow the wholesale network deliberately. Not every application will be accepted — not because your business isn’t excellent, but because we want to protect the density of the network so every partner can succeed.",
}];

export default function WholesalePage() {
  return (
    <PageShell
      slug="wholesale"
      testid="wholesale"
      eyebrow="Wholesale & B2B"
      title="Bring Scentodore to your clientele."
      intro="We partner with a curated network of boutiques, salons, spas, hotels, and corporate gifting programmes. If your customers value considered, French-inspired fragrance, we should talk."
    >
      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">Who we work with</h2>
        <EditableFeatureGrid slug="wholesale" sectionKey="partners" fallback={PARTNERS} />
      </div>

      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">Partnership benefits</h2>
        <EditableFeatureGrid slug="wholesale" sectionKey="benefits" fallback={BENEFITS} />
      </div>

      <EditableSection slug="wholesale" sectionKey="process" fallback={PROCESS} />
      <EditableSection slug="wholesale" sectionKey="note" fallback={NOTE} />

      <div className="-mt-8 flex flex-wrap gap-3">
        <Link
          to="/contact"
          data-testid="wholesale-apply-cta"
          className="inline-flex items-center gap-2 bg-[#1A1918] text-[#FAF8F5] px-5 py-3 rounded-xl text-xs uppercase tracking-[0.18em] hover:bg-[#C5A059] hover:text-[#0B0A08] transition-colors"
        >
          Apply for partnership <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </PageShell>
  );
}
